<template>
  <footer class>
    <div class="container pt-4 pb-4">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mt-4 d-none d-lg-block">
          <h3 class="mb-5">เกี่ยวกับเรา</h3>
          <p class="max-width">
            <img
              src="../assets/logo.png"
              class="mx-auto mb-3 d-block"
              alt="thong firearms"
            />
            ร้านปืนธงก่อตั้งเมื่อประมาณปี พ.ศ. 2490
            ซึ่งเป็นการเปิดกิจการร้านขายปืนในยุคสมัยแรกๆของประเทศไทย
            ในย่านวังบูรพา ประสบการณ์ที่สั่งสมมานานจากรุ่นสู่รุ่น
            ทำให้ร้านปืนธงมีชื่อเสียงในด้านความรู้ของอาวุธปืนเป็นอย่างดี...&nbsp;
            <router-link to="/about-us" class="text-light read-more"
              >อ่านต่อ</router-link
            >
          </p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mt-4">
          <h3 class="mb-5">ติดต่อเรา</h3>
          <h4>ห้างหุ้นส่วนจำกัด ปืนธง</h4>
          <p>
            ที่อยู่ : 5 ถนนบูรพา แขวงวังบูรพาภิรมย์ เขตพระนคร กรุงเทพมหานคร
            10200
          </p>
          <p>วันทำการ : วันจันทร์ - วันเสาร์</p>
          <p>เวลาทำการ : 9:00 - 17:00 น.</p>
          <p class>
            <a
              class="text-light d-flex align-items-center"
              target="_bank"
              href="tel:022227784"
            >
              <i class="fas fa-phone-square font-size-25"></i>&nbsp; 02-222-7784
              <!-- , 065-198-9891 -->
            </a>
          </p>
          <p>
            <a
              class="text-light d-flex align-items-center"
              target="_bank"
              href="https://www.facebook.com/profile.php?id=61569913006234"
            >
              <i class="fab font-size-25 fa-facebook-square"></i>&nbsp; ปืนธง Thong
            </a>
          </p>
          <p>
            <a
              class="text-light d-flex align-items-center"
              target="_bank"
              href="line://ti/p/%40nbq8455j"
            >
              <i class="fab font-size-25 fa-line"></i>&nbsp; @thong.arms
            </a>
          </p>
          <p>
            <a
              class="text-light d-flex align-items-center"
              target="_bank"
              href="https://www.instagram.com/thongfirearms/profilecard"
            >
              <i class="fab font-size-25 fa-instagram"></i>&nbsp; @thongfirearms
            </a>
          </p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mt-4">
          <h3 class="mb-5">แผนที่</h3>
          <iframe
            title="แผนที่ร้านปืนธง ขายปืน วังบูรพา"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.536262672678!2d100.49878466540672!3d13.746502740350891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29910abc291fd%3A0xba83e19983b0357!2z4Lib4Li34LiZ4LiY4LiH!5e0!3m2!1sth!2sth!4v1530179605854"
            height="450"
            frameborder="0"
            style="border: 0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <div class="bg-black pt-2 pb-2 text-center">
      <div class="container">
        Copyright © 2018-{{ new Date().getFullYear() }} Thongarms.com
      </div>
    </div>
    <b-modal
      id="modal-center"
      v-model="show"
      centered
      ok-only
      header-border-variant="white"
      footer-border-variant="white"
      ok-title="รับทราบ"
      ok-variant="danger"
    >
      <h3 class="mx-4">
        สำหรับผู้มีใบอนุญาตซื้อปืน (ป.3) เท่านั้น
        และต้องมาซื้อเองที่ร้านในเวลาราชการตามกฎหมายกำหนด
      </h3>
    </b-modal>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    };
  },
  components: {}
};
</script>

<style scoped>
footer {
  color: #fff;
  background: #111;
  position: relative;
  z-index: 999;
}
.read-more,
.read-more:hover {
  font-size: 14px;
  text-decoration: underline;
}
a:hover {
  text-decoration: none;
}
iframe {
  width: 100%;
  height: 170px;
}
p {
  margin-bottom: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/component/footer.vue